import {  List } from 'antd';
import MoneyFormat from 'components/UI/Money/MoneyFormat';
import Text from 'components/UI/Text/Text';
import { getLocalCurrency } from 'context/currency';
import { CURRENCY_ARIARY, CURRENCY_EURO } from 'library/helpers/constUtils';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import * as icons from "react-icons/fa";
import GridCardWrapper, {
  ContentWrapper,
  ImageWrapper,
  MetaWrapper,
  PriceArea,
  TitleArea
} from './GridRoom.style';
import { getIconeUrlById, remplaceSlashNByBr} from 'library/helpers/fonction';

const GridRoomDetail = ({
  className,
  children,
  chambreData,
  hotel,
  dayUseParams = {}
}) => {
  
  const [currency, setCurrency] = useState(getLocalCurrency());

  const [equipementData, setEquipementData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [extrasData, setExtrasData] = useState([]);

  useEffect(() =>{
    setCurrency(getLocalCurrency());
  },[])
 
  const getRoomPrice = (currency) => {
    if (dayUseParams.isDayUse) {
      return currency == CURRENCY_EURO ? dayUseParams.prixDayUseEuro : prixDayUseAriary
    }
    return chambreData.tarifs.find(tarif => tarif.currency === currency)?.tarif;
  }

  const groupByCategory = (data) => {
    return data.reduce((acc, item) => {
      // Regrouper les éléments par catégorie
      if (!acc[item.categorie]) {
        acc[item.categorie] = [];
      }
      acc[item.categorie].push(item);
      return acc;
    }, {});
  };

  const ListDiversInChambre = ({headerTxt, listData}) => {
   
    let Icon = icons["FaRegCheckCircle"];
    if(headerTxt=="Extras") {
      return (
            <List
                size="small"
                header={<div style={{ fontSize:"18px"}}><b>{headerTxt}</b></div>}
                dataSource={listData}
                renderItem={(item) => {
                  let tarif = item?.prixAriary?<MoneyFormat value={currency == "€" ?item?.prixEuro:item?.prixAriary} suffix={currency == "€" ?' €':' Ar'}/> :'';
                  let Icon = icons["FaRegCheckCircle"];
                  return (<List.Item> {item.idIcone ? <img src={getIconeUrlById(item.idIcone)} alt={item.nomIcone} className="icone-option-0"/>:<Icon className='ant-btn-link' style={{margin:"0px 5px -1px 0px"}}/>} {item?.description ?? item?.libelle} {tarif!=''?' (':''}{tarif}{tarif!=''?')':''}</List.Item>)
                }
              }
            />
      )
    }else {
      const groupedData = groupByCategory(listData);
      return(
      <> 
        <div className='titre-list'><div style={{paddingBottom: "10px"}}><b>{headerTxt}</b></div></div>
        {
        Object.keys(groupedData).map((categorie, index) => (
            <div key={index} className="category-group">
              <h4><b>{categorie}</b></h4>
              <ul className="category-list">
                {groupedData[categorie].map((item) => (
                  <li key={item.id}>
                    {item.idIcone ? <img src={getIconeUrlById(item.idIcone)} alt={item.nomIcone} className="icone-option-0"/>:<Icon className='ant-btn-link' style={{margin:"0px 5px -1px 0px"}}/>} 
                    {item.description}
                  </li>
                ))}
              </ul>
            </div>
          ))
          }
        </>
      );
    }

    
  };

  const ListLit =  ({headerTxt, listData}) => {
    return (
      <List
          size="small"
          header={<div style={{ fontSize:"18px"}}><b>{headerTxt}</b></div>}
          dataSource={listData}
          renderItem={(item) => {
            return item?.nombre>0?(<List.Item> {item?.type ?? ''} : <b>{ item?.nombre??0}</b></List.Item>):null
          }
        }
        />
    )
  };

  useEffect(() => {
    if (chambreData.id) {
      const dataFetch = async () => {
        let baseUrl = process.env.REACT_APP_API_URL;
        const result = (
          await Promise.all([
            fetch(`${baseUrl}/equipements`),
            fetch(`${baseUrl}/services`),
            fetch(`${baseUrl}/extras/idhotel/${hotel}`)
          ])
        ).map((r) => r.json());
  
        const [ listEquipement, listService, listExtra ] = await Promise.all(
          result
        );
        
        setEquipementData(listEquipement.filter(item => chambreData.idEquipements.includes(item.id)));
        setServiceData(listService.filter(item => chambreData.idServices.includes(item.id)));
        setExtrasData(listExtra.filter(item => chambreData.idExtras.includes(item.id)));
        
       };
  
       dataFetch();
    }

  }, [hotel, chambreData]);

  return (
    <GridCardWrapper >
      <ImageWrapper className="media_wrapper11">{children}</ImageWrapper>
      {chambreData?.id && <ContentWrapper className="content_wrapper">
        {chambreData.nomTypeHebergement && 
        <TitleArea>
           <Text content={`${chambreData.nomChambre} (${chambreData.nomTypeHebergement})`} style={{ color: '#2C2C2C' }}/>           
        </TitleArea>
        }

        <MetaWrapper className="meta_wrapper">
         <PriceArea className="price price-gras">
          <MoneyFormat value={currency === "€" ? getRoomPrice(CURRENCY_EURO) : getRoomPrice(CURRENCY_ARIARY)} suffix={` ${currency}`}/>
         </PriceArea>
        </MetaWrapper>

        <MetaWrapper>
          <Text content={ remplaceSlashNByBr(chambreData.description) }></Text>
        </MetaWrapper>
       
          {equipementData?.length > 0 && <MetaWrapper>
              <ListDiversInChambre headerTxt="Equipements" listData={equipementData} />
          </MetaWrapper>}
           
          {serviceData?.length > 0 && <MetaWrapper>
            <ListDiversInChambre headerTxt="Services" listData={serviceData} />
          </MetaWrapper>}
        
          {extrasData?.length > 0 && <MetaWrapper>
            <ListDiversInChambre headerTxt="Extras" listData={extrasData} />
          </MetaWrapper>}

          <MetaWrapper>
            <ListLit headerTxt="Lits" listData={chambreData?.lits} />
          </MetaWrapper>

      </ContentWrapper>}
    </GridCardWrapper>
  );
};

GridRoomDetail.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  price: PropTypes.string,
  rating: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  location: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  editBtn: PropTypes.element,
  viewDetailsBtn: PropTypes.element,
};

export default GridRoomDetail;
